var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-results"},[_c('div',{staticClass:"no-results--container"},[_vm._m(0),_c('br'),_vm._t("default",function(){return [_c('h2',[_vm._v("Whoops! Looks like we do not have content related to your query.")])]})],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animation"},[_c('div',{staticClass:"loader_gear"}),_c('i',{staticClass:"far fa-exclamation-circle symbol"})])
}]

export { render, staticRenderFns }